<template>
  <div class="rounded-lg bg-black">
    <CollapsibleComponent>
      <template #title>
        <div
          class="flex items-center gap-2 rounded-lg py-2 pl-3 pr-1 text-xs font-semibold text-dark-gray"
        >
          <img
            class=""
            src="@/assets/loads/triumph-full-white.svg"
            alt="triumph logo"
          />
        </div>
      </template>
      <template #icon>
        <img
          class="mr-2.5 h-4 w-4"
          src="@/assets/next-icon.svg"
          alt="arrow icon"
        />
      </template>
      <template #content>
        <div class="triumph-container rounded-b-lg p-[1px]">
          <div
            class="flex flex-col gap-4 rounded-b-lg bg-white px-4 py-3 text-left"
          >
            <div
              v-if="tfxComingSoonEnabled"
              class="flex flex-col gap-2"
            >
              <p class="text-lg font-semibold text-steel-900">
                Triumph
                <span class="font-normal text-steel-700">Factoring</span>
              </p>

              <p class="font-normal text-steel-800">
                Triumph Factoring provides trucking companies fast, predictable
                and secure payments with 24/7 funding options and access to
                solutions like fuel cards and insurance.
              </p>

              <div class="flex gap-4">
                <ButtonComponent class="flex flex-1 justify-center !py-3">
                  <a
                    href="https://triumph.io/carrier/factoring/?utm_campaign=17652850-TFX&utm_source=Highway&utm_medium=Learn%20More&utm_term=Triumph&utm_content=Factoring"
                    target="_blank"
                  >
                    Learn More
                  </a>
                </ButtonComponent>
                <ButtonComponent
                  class="flex flex-1 justify-center !bg-[#28D2D1] !py-3 hover:bg-[#28D2D1] hover:!bg-opacity-70"
                >
                  <a
                    href="https://apply.triumph.io/carriers/?utm_source=highway-loadboard&utm_campaign=17652850-TFX&utm_source=Highway&utm_medium=In%20App&utm_term=Triumph&utm_content=Factoring"
                    target="_blank"
                  >
                    Apply Now
                  </a>
                </ButtonComponent>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <p class="flex gap-2 text-lg text-steel-900">
                <img
                  class="items-center text-2xs"
                  src="@/assets/loads/load-pay.svg"
                  alt="load pay"
                />
                LoadPay
              </p>

              <p class="font-normal text-steel-800">
                LoadPay is a digital banking solution built for trucking,
                offering 24/7 invoice payments in minutes, fuel card
                integrations, cash advances on eligible loads, and business
                management tools.
              </p>

              <div class="flex gap-4">
                <ButtonComponent class="flex flex-1 justify-center !py-3">
                  <a
                    href="https://loadpay.com/?utm_campaign=17652850-TFX&utm_source=Highway&utm_medium=Learn%20More&utm_term=Triumph&utm_content=LoadPay"
                    target="_blank"
                  >
                    Learn More
                  </a>
                </ButtonComponent>
                <ButtonComponent
                  class="flex flex-1 justify-center !bg-[#28D2D1] !py-3 hover:bg-[#28D2D1] hover:!bg-opacity-70"
                >
                  <a
                    href="https://app.loadpay.com/app/signup/highway?utm_campaign=17652850-TFX&utm_source=Highway&utm_medium=In%20App&utm_term=Triumph&utm_content=LoadPay"
                    target="_blank"
                  >
                    Apply Now
                  </a>
                </ButtonComponent>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollapsibleComponent>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, computed } from 'vue';
import { useStore } from 'vuex';
import { ButtonComponent, CollapsibleComponent } from '@/components';

const store = useStore();
const isOpen = ref(false);

const tfxComingSoonEnabled = computed(() => {
  return store.state.users.featureFlags?.carrier_triumph_factoring_ad?.enabled;
});

onBeforeMount(() => {
  setTimeout(() => {
    isOpen.value = true;
  }, 500);
});
</script>

<style>
.triumph-container {
  @apply bg-black;
}
</style>
